<template>
  <form novalidate="true" @submit.prevent="submit">
    <b-notification type="is-danger" :active="error !== null" :closable="false">
      {{ error }}
    </b-notification>
    <b-field group-multiline grouped class="columns">
      <b-field
        label="Status"
        :message="fields.availability.error"
        :type="fields.availability.error !== null ? 'is-danger' : ''"
        class="column is-full-mobile"
      >
        <b-input v-if="isUnavailable" disabled :value="unavailable" />
        <b-select
          v-else
          v-model="fields.availability.value"
          placeholder="Choisir un status"
          icon="history"
          expanded
        >
          <option
            v-for="availability in Object.keys(availabilities)"
            :key="availability"
            :value="availability"
          >
            {{ availabilities[availability] }}
          </option>
        </b-select>
      </b-field>
      <b-field
        label="Propriétaire"
        :message="fields.owner.error"
        :type="fields.owner.error !== null ? 'is-danger' : ''"
        class="column is-full-mobile"
      >
        <b-select v-model="fields.owner.value" label="Choisir un propriétaire" icon="user" expanded>
          <option v-for="owner in owners" :key="owner" :value="owner">
            {{ capitalize(owner) }}
          </option>
        </b-select>
      </b-field>
      <b-field
        label="Usure"
        :message="fields.wear.error"
        :type="fields.wear.error !== null ? 'is-danger' : ''"
        class="column is-full-mobile"
      >
        <b-select v-model="fields.wear.value" expanded>
          <option v-for="wear in wears" :key="wear.value" :value="wear.value">
            {{ wear.label }}
          </option>
        </b-select>
      </b-field>
    </b-field>
    <b-field
      label="Commentaire"
      :message="fields.comment.error"
      :type="fields.comment.error !== null ? 'is-danger' : ''"
    >
      <b-input v-model="fields.comment.value" type="textarea" />
    </b-field>
    <hr />
    <b-field>
      <b-button native-type="submit" type="is-primary" :loading="loading" :disabled="isUnavailable">
        Modifier
      </b-button>
    </b-field>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { capitalize } from '@helpers/capitalize'
import { AVAILABILITIES, AVAILABILITY_UNAVAILABLE } from '@constants/tracker/availability.js'
import { OWNERS } from '@constants/tracker/owner.js'
import { WEARS } from '@constants/tracker/wear.js'

export default {
  name: 'NeyosTrackerEditForm',

  props: {
    neyosTracker: {
      type: Object,
      required: true,
      validator: (v) => ['id', 'owner', 'comment', 'availability'].every((key) => key in v),
    },
  },

  data() {
    return {
      error: null,
      loading: false,
      fields: {
        availability: {
          value: null,
          error: null,
        },
        comment: {
          value: null,
          error: null,
        },
        owner: {
          value: null,
          error: null,
        },
        wear: {
          value: 0,
          error: null,
        },
      },
    }
  },

  created() {
    this.owners = OWNERS
    this.wears = WEARS
    this.unavailable = AVAILABILITIES[AVAILABILITY_UNAVAILABLE]
    this.availabilities = Object.fromEntries(
      Object.entries(AVAILABILITIES).filter(([key]) => key !== AVAILABILITY_UNAVAILABLE),
    )
  },

  watch: {
    neyosTracker: {
      handler: 'load',
      immediate: true,
    },
  },

  computed: {
    isUnavailable() {
      return this.neyosTracker.availability === AVAILABILITY_UNAVAILABLE
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    load() {
      this.fields.availability.value = this.neyosTracker.availability
      this.fields.comment.value = this.neyosTracker.comment
      this.fields.owner.value = this.neyosTracker.owner
      this.fields.wear.value = this.neyosTracker.wear
    },

    async submit() {
      this.error = null
      this.loading = true

      try {
        const neyosTracker = await this.$services.neyosTrackerService.update(this.neyosTracker.id, {
          availability: this.fields.availability.value,
          comment: this.fields.comment.value,
          owner: this.fields.owner.value,
          wear: this.fields.wear.value,
        })
        this.$emit('update:neyosTracker', neyosTracker)
        this.addToastMessage({
          text: 'Les modifications ont bien été enregistré.',
          type: 'is-success',
        })
      } catch (err) {
        this.error = 'Une erreur interne est survenue.'
        console.error(err)
      }

      this.loading = false
    },

    capitalize(value) {
      return capitalize(value)
    },
  },
}
</script>
